// extracted by mini-css-extract-plugin
export default {"serviceListTabs":"ServicesTabs_serviceListTabs__3xDuk","serviceListTabsActive":"ServicesTabs_serviceListTabsActive__Rml0x"};